
$(function () {

    /***
     *
     * MODAL HANDLERS
     *
     */

    /** Modal Pilot handlers and variables */
    (function () {
        var pilotID;
        $('#modal-pilots').on('show.bs.modal', function (e) {
            pilotID = $(e.relatedTarget).data('id');
            getUserData(pilotID);
        });

        $('button.admin-pilot-approve').on('click', function (e) {

            var token = $('meta[name="csrf-token"]').attr('content');
            var comments = $('.modal__comment-box').val();

            $.ajax({
                url: "/admin/grantPilot",
                type: "POST",
                data: {
                    'id': pilotID,
                    'reviewer_comments': comments
                },
                headers: {
                    'X-CSRF-TOKEN': token
                },
                success: function (result) {
                    location.reload();
                },
                error: function (error) {
                    console.log(error);
                }
            })
        });

        $('button.admin-user-reject').on('click', function (e) {

            if (!confirm('Are you sure you want to reject this pilot?')) return;

            var token = $('meta[name="csrf-token"]').attr('content');

            $.ajax({
                url: "/admin/rejectUser",
                type: "POST",
                data: {
                    'id': pilotID
                },
                headers: {
                    'X-CSRF-TOKEN': token
                },
                success: function (result) {
                    location.reload();
                },
                error: function (error) {
                    console.log(error);
                }
            })
        });
    })();



    /** Modal Client handlers and variables */
    (function () {
        var clientID;
        $('#modal-clients').on('show.bs.modal', function (e) {
            clientID = $(e.relatedTarget).data('id');
            getUserData(clientID);
        });

        $('button.admin-client-approve').on('click', function (e) {

            var token = $('meta[name="csrf-token"]').attr('content');
            var comments = $('.modal__comment-box').val();

            $.ajax({
                url: "/admin/grantPilot",
                type: "POST",
                data: {
                    'id': clientID,
                    'reviewer_comments': comments
                },
                headers: {
                    'X-CSRF-TOKEN': token
                },
                success: function (result) {
                    location.reload();
                },
                error: function (error) {
                    console.log(error);
                }
            })
        });

        $('button.admin-user-reject').on('click', function (e) {

            if (!confirm('Are you sure you want to reject this client?')) return;

            var token = $('meta[name="csrf-token"]').attr('content');

            $.ajax({
                url: "/admin/rejectUser",
                type: "POST",
                data: {
                    'id': clientID
                },
                headers: {
                    'X-CSRF-TOKEN': token
                },
                success: function (result) {
                    location.reload();
                },
                error: function (error) {
                    console.log(error);
                }
            })
        });
    })();



    /** Modal Create Mission handlers and variables */
    (function () {
        $('#modal-create-mission').on('show.bs.modal', function (e) {
        });

        // number <-> checkmark frontend hacks
        $('#modal-create-mission #btnNext').on('click', function () {

            var token = $('meta[name="csrf-token"]').attr('content');
            var activeTab = $('.step-nav .active');
            var activeLink = activeTab.attr('href');
            var url = null;
            var data = null;

            switch (activeLink) {
                case '#missionDetails':
                    url = "/mission/create/detail";
                    data = $('#form-missionDetails').serializeArray();
                    break;
                case '#location':
                    url = "/mission/create/location";
                    data = $('#form-missionLocation').serializeArray();
                    break;
                case '#dataRequirements':
                    url = "/mission/create/requirements";
                    data = $('#form-requirements').serializeArray();
                    break;
                case '#summary':
                    url = "/mission/create/summary";
                    data = $('#form-requirements').serializeArray();
                    break;
                default:
            }

            if (url) {
                $.ajax({
                    url: url,
                    type: "POST",
                    data: data,
                    headers: {
                        'X-CSRF-TOKEN': token
                    },
                    success: function (response) {

                        // Reset all error messages before processing
                        let errorBlock = $('.form-errors');
                        errorBlock.each(function () {
                            $(this).addClass('d-none');
                            $(this).removeClass('d-block');
                        });
                        $('#summary .summary-error').addClass('d-none').removeClass('d-block');

                        if (response.status == "error") {

                            errorToast();

                            for (let key in response.data) {
                                let input = $(`.form-control[name="${key}"]`).siblings('.form-errors');
                                input.text(response.data[key][0]);
                                input.removeClass('d-none');
                                input.addClass('d-block');
                            }

                            $('#summary .summary-error')
                                .text(response.data)
                                .removeClass('d-none')
                                .addClass('d-block');
                        } else {
                            $('#missionDetails').find('.form-control[name="id"]').attr('value', response.data.id);
                            $('#location').find('.form-control[name="id"]').attr('value', response.data.id);
                            $('#dataRequirements').find('.form-control[name="id"]').attr('value', response.data.id);
                            $('#summary').find('.form-control[name="id"]').attr('value', response.data.id);

                            $(`.step-nav__link .active[href='${activeLink}']`).parent('li').addClass('complete'); // checkmark for navigation
                            $('.step-nav .active').parent('li').addClass('complete').next('li').find('a').trigger('click');

                            if (activeLink == '#summary') {
                                $('#modal-create-mission .modal-body').html(`
                                    <div class="completed-body">
                                        <p class="h3">Congratulations!</p>
                                        <p>This mission is created. Click <a href="#" class="completed-body-button" data-id='${response.data.id}'>here</a> to view the mission details.</p>
                                        <p>Once your mission is submitted we will respond within 24 hours with pricing. A 50% deposit will be required for all missions.*</p>
                                        <button type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-missions" data-id='${response.data.id}'>View Details</button>
                                    </div>
                                `);
                                // On this final page, the next button should be hidden
                                $('#modal-create-mission #btnNext').hide();

                                $('#modal-create-mission .modal-body .completed-body .completed-body-button').on('click', (e) => {
                                    $('#modal-create-mission').modal('hide');

                                    // hack to let scrolling work on new modal.
                                    setTimeout(function () {
                                        $('#modal-create-mission .modal-body .completed-body button').trigger('click');
                                        $('#modal-create-mission .modal-body .completed-body .completed-body-button').off('click');
                                    }, 1000);
                                });

                                // The mission is complete and the modal is done. Reload the page
                                $('#modal-create-mission').on('hidden.bs.modal', function () {
                                    location.reload();
                                });
                            }

                            successToast();
                        }
                    },
                    error: function (error) {
                        errorToast();
                        console.log(error);
                    }
                })
            }
        });


        $('#modal-create-mission #summary-tab').on('shown.bs.tab', function () {
            var id = $('#summary').find('.form-control[name="id"]').attr('value');
            if (id) {
                $.ajax({
                    url: `/mission/${id}`,
                    type: "GET",
                    headers: {
                        'X-CSRF-TOKEN': token
                    },
                    success: function (response) {
                        var summary = $('#summary');
                        var data = response.data;
                        var dateStart = new Date(data.date_start);
                        var dateEnd = new Date(data.date_end);

                        var timeFormat24To12 = (hours, minutes) => {
                            if (hours == 0) return `12:${minutes.toString().padStart(2, "0")} AM`;

                            output = "";
                            output += hours > 12 ? hours % 12 : hours;
                            output += `:${minutes.toString().padStart(2, "0")} `;
                            output += hours >= 12 ? 'PM' : 'AM';

                            return output;
                        };

                        summary.find('.form-group [name="companyName"]').attr('value', data.mission_contact ? data.mission_contact.company : '');
                        summary.find('.form-group [name="primaryContactFirstName"]').attr('value', data.mission_contact ? data.mission_contact.contact_first_name : '');
                        summary.find('.form-group [name="primaryContactLastName"]').attr('value', data.mission_contact ? data.mission_contact.contact_last_name : '');
                        summary.find('.form-group [name="email"]').attr('value', data.mission_contact ? data.mission_contact.email : '');
                        summary.find('.form-group [name="phone"]').attr('value', data.mission_contact ? data.mission_contact.phone : '');
                        summary.find('.form-group [name="missionAddress"]').attr('value', data.mission_contact ? data.mission_contact.address1 : '');
                        summary.find('.form-group [name="missionAddress2"]').attr('value', data.mission_contact ? data.mission_contact.address2 : '');
                        summary.find('.form-group [name="missionCity"]').attr('value', data.mission_contact ? data.mission_contact.city : '');
                        summary.find('.form-group [name="missionCountry"]').attr('value', data.mission_contact ? data.mission_contact.country.country : '');
                        summary.find('.form-group [name="missionState"]').attr('value', data.mission_contact ? data.mission_contact.state.state : '');
                        summary.find('.form-group [name="missionZip"]').attr('value', data.mission_contact ? data.mission_contact.zip : '');

                        summary.find('.form-group [name="missionName"]').attr('value', data.mission);
                        summary.find('.form-group [name="missionDate"]').attr('value', `${dateStart.getMonth() + 1}/${dateStart.getDate()}/${dateStart.getFullYear()}`);
                        summary.find('.form-group [name="missionStartTime"]').attr('value', timeFormat24To12(dateStart.getHours(), dateStart.getMinutes()));
                        summary.find('.form-group [name="missionEndTime"]').attr('value', timeFormat24To12(dateEnd.getHours(), dateEnd.getMinutes()));
                        summary.find('.form-group [name="problemSolve"]').text(data.objective);
                        summary.find('.form-group [name="otherInfo"]').text(data.other_information);
                        summary.find('.form-group [name="typeStructure"]').attr('value', data.structure_type);
                        data.flight_over_people_active_road ? summary.find('.form-group [name="checkboxOver"]').attr('checked', 'checked') : summary.find('.form-group [name="checkboxOver"]').removeAttr('checked');
                        data.ppe_required ? summary.find('.form-group [name="checkboxPPE"]').attr('checked', 'checked') : summary.find('.form-group [name="checkboxPPE"]').removeAttr('checked');
                        data.sst_required ? summary.find('.form-group [name="checkboxSST"]').attr('checked', 'checked') : summary.find('.form-group [name="checkboxSST"]').removeAttr('checked');

                        summary.find('.form-group [name="locationAddress"]').attr('value', data.address1);
                        summary.find('.form-group [name="locationAddress2"]').attr('value', data.address2);
                        summary.find('.form-group [name="locationCity"]').attr('value', data.city);
                        summary.find('.form-group [name="locationCountry"]').attr('value', data.country ? data.country.country : '');
                        summary.find('.form-group [name="locationState"]').attr('value', data.state ? data.state.state : '');
                        summary.find('.form-group [name="locationZip"]').attr('value', data.zip);

                        summary.find('.form-group [name="dataFormat"]').attr('value', data.data_format ? data.data_format.map(row => row.type).join(', ') : '');
                    },
                    error: function (error) {

                        console.log(error);
                    }
                });
            }

            // Change the button to Create Mission
            $('#modal-create-mission #btnNext').text('Create Mission').removeClass('btn-primary').addClass('btn btn-success');
        }).on('hide.bs.tab', function () {
            // Change the button back to Next
            $('#modal-create-mission #btnNext').text('Next').removeClass('btn-success').addClass('btn-primary');
        });
    })();

    /** Modal Missions handlers and variables */
    (function () {
        // Mission Id is available within this entire closure
        var missionId;

        $('#modal-missions').on('show.bs.modal', function (e) {
            missionId = $(e.relatedTarget).data('id');
            var pilotsDropdown = $('.assigned-pilots-picker');
            var statusDropdown = $('.mission-status-picker');
            var token = $('meta[name="csrf-token"]').attr('content');

            pilotsDropdown.html('');
            statusDropdown.html('');
            axios.all([
                axios.get(`/mission/${missionId}`),
                axios.get('/admin/list/pilots'),
                axios.get(`/admin/list/missionStatus`),
            ])
                .then(axios.spread((missionResponse, pilotsResponse, statusResponse) => {
                    mission = missionResponse.data.data;
                    pilots = pilotsResponse.data;
                    statuses = statusResponse.data;

                    var setFieldData = (key, value) => {
                        $(`.mission-entry .mission-entry-data[name="${key}"]`).text(value);
                    }
                    var data = mission;

                    setFieldData('clientName', `${data.mission_contact.contact_first_name} ${data.mission_contact.contact_last_name}`);
                    setFieldData('missionName', data.mission);
                    setFieldData('instructions', data.objective);
                    setFieldData('typeStructure', data.structure_type);
                    setFieldData('dataFormat', data.data_format ? data.data_format.map(row => row.type).join(', ') : '');
                    setFieldData('ppeRequired', data.ppe_required ? 'Yes' : 'No');
                    setFieldData('flightOver', data.flight_over_people_active_road ? 'Yes' : 'No');
                    setFieldData('otherInfo', data.other_information);
                    setFieldData('contactName', `${data.mission_contact.contact_first_name} ${data.mission_contact.contact_last_name}`);
                    setFieldData('contactPhone', data.mission_contact.phone);
                    setFieldData('contactEmail', data.mission_contact.email);

                    setFieldData('missionAddress', data.address1);
                    setFieldData('missionAddress2', data.address2);
                    setFieldData('missionCity', data.city);
                    setFieldData('missionState', data.state.state !== undefined ? data.state.state : '');
                    setFieldData('missionCountry', data.country.country !== undefined ? data.country.country : '');
                    setFieldData('missionCoordinates', data.locations ? `${data.locations[0].latitude}, ${data.locations[0].longitude}` : '');
                    setFieldData('authority', data.authority_check ? 'Yes' : 'No');
                    setFieldData('propertyType', data.property_type ? data.property_type.type : 'N/A');
                    setFieldData('reviewerComment', data.reviewer_comments);

                    if (data.locations) { setMap('mission1', parseFloat(data.locations[0].latitude), parseFloat(data.locations[0].longitude)); }

                    // Hide 'Claim Mission' button if mission status is not 'Open'
                    if (data.status_id != 3) {
                        $('.modal-missions__claim-mission-button').hide();
                    }

                    pilotsDropdown.append(`<option disabled ${mission.pilot ? '' : 'selected'}>None</option>`);
                    pilots.forEach(pilot => {
                        pilotsDropdown.append(`<option ${mission.pilot ? (mission.pilot.id == pilot.id ? 'selected' : '') : ''} value="${pilot.id}">${pilot.first_name} ${pilot.last_name}</option>`)
                    });

                    statusDropdown.append(`<option disabled ${mission.status ? '' : 'selected'}></option>`);
                    statuses.forEach(status => {
                        statusDropdown.append(`<option ${mission.status.id == status.id ? 'selected' : ''} value="${status.id}">${status.description}</option>`)
                    });
                }))
                .catch(error => {
                    console.log(error);
                });

        });
        $('#modal-missions').on('hide.bs.modal', function (e) {
            var setFieldData = (key, value) => {
                $(`.mission-entry .mission-entry-data[name="${key}"]`).text(value);
            }

            setFieldData('clientName', '');
            setFieldData('missionName', '');
            setFieldData('instructions', '');
            setFieldData('typeStructure', '');
            setFieldData('dataFormat', '');
            setFieldData('ppeRequired', '');
            setFieldData('flightOver', '');
            setFieldData('otherInfo', '');

            setFieldData('contactName', '');
            setFieldData('contactPhone', '');
            setFieldData('contactEmail', '');

            setFieldData('missionAddress', '');
            setFieldData('missionCoordinates', '');
            setFieldData('authority', '');
            setFieldData('propertyType', '');
        });

        $('#modal-missions .update-mission').on('click', function () {
            if (!confirm('Are you sure you want to update this mission?')) return;

            url = `/admin/mission/${missionId}`;
            data = $('#form-viewMission').serializeArray();
            $.post({
                url: url,
                headers: {
                    'X-CSRF-TOKEN': token
                },
                data: data,
                success: function (response) {
                    successToast('Mission Updated');
                    $('#modal-missions').modal('hide');
                },
                error: function (error) {
                    console.log(error);
                }
            });
        });

        $('#modal-missions .modal-missions__claim-mission-button').on('click', function () {
            // Try to claim mission
            url = `/mission/edit/${missionId}/assign`;
            $.post({
                url: url,
                headers: {
                    'X-CSRF-TOKEN': token
                },
                success: function () {
                    // If mission is claimed, go to mission details page after success message
                    successToast('Mission claimed');
                    setTimeout(function () {
                        window.location = `/portal/missions/details/${missionId}`;
                    }, 2000);
                },
                error: function (xhr) {
                    var message = xhr.responseText;
                    if (!message || message.length > 300) message = 'Error';
                    errorToast(message);
                }
            });

        });
    })();


    /***
     * FUNCTIONS
     */

    let getUserData = (userID) => {
        $.ajax({
            url: "/admin/getUser/" + userID,
            type: "GET",
            headers: {
                'X-CSRF-TOKEN': token
            },
            success: function (result) {
                for (obj in result) {
                    if (obj === "insurance") {
                        for (key in result.insurance) {
                            if (key === "proof_of_insurance_path") {
                                $(`.user__insure-${key}`).html(
                                    result.insurance[key] ? `<a href="${result.insurance[key]}">Download</a>` : 'None'
                                );
                            } else {
                                $(`.user__insure-${key}`).html(result.insurance[key])
                            }
                        }
                    }
                    else if (obj === "credential") {
                        let cert = '',
                            reg_num = '';
                        for (arr in result.credential) {
                            cert += `<div>${result.credential[arr].certification}</div>`;
                            // JIRA-221 - registration_number is removed
                            //reg_num += `<div>${result.credential[arr].registration_number}</div>`;
                        }
                        $(`.user__${obj}-cert`).html(cert);
                        $(`.user__${obj}-reg_num`).html(reg_num);
                    }
                    else if (obj === "equipment") {
                        let drones = '',
                            faa_reg = '',
                            sensors = '',
                            cameras = '',
                            software = '',
                            other = '';
                        for (arr in result.equipment.drones) {
                            drones += `<div>${result.equipment.drones[arr]}</div>`;
                            faa_reg += `<div>${result.equipment.drone_inventory[arr].registered.faa_registration}</div>`;
                        }
                        for (arr in result.equipment.sensors) {
                            sensors += `<div>${result.equipment.sensors[arr].name}</div>`;
                        }
                        for (arr in result.equipment.cameras) {
                            cameras += `<div>${result.equipment.cameras[arr].name}</div>`;
                        }
                        for (arr in result.equipment.softwares) {
                            software += `<div>${result.equipment.softwares[arr].name}</div>`;
                        }
                        for (arr in result.equipment.additional) {
                            other += `<div>${result.equipment.additional[arr].name}</div>`;
                        }
                        $(`.user__${obj}-drones`).html(drones);
                        $(`.user__${obj}-faa_reg`).html(faa_reg);
                        $(`.user__${obj}-sensors`).html(sensors);
                        $(`.user__${obj}-cameras`).html(cameras);
                        $(`.user__${obj}-software`).html(software);
                        $(`.user__${obj}-additional`).html(other);
                    }
                    else if (obj === "phone") {
                        $(`.user__${obj}`).html(result[obj].phone_number);
                    }
                    else if (obj === "consent") {
                        $(`.user__${obj}`).html(
                            result[obj] ? `Yes` : 'No'
                        );
                    }
                    else if (obj == "user_verification_status") {
                        // User verification status will determine whether an admin
                        // button is to be shown
                        // For unverified users, an admin can approve or reject the user
                        var status = result[obj];
                        var selectorsToShowIfUnverified = [
                            '.form-check-container',
                            '.admin-user-reject',
                            '.admin-client-approve',
                            '.admin-pilot-approve',
                        ].join(', ');
                        if (status == 'unverified') {
                            $(selectorsToShowIfUnverified).show();
                        } else {
                            $(selectorsToShowIfUnverified).hide();
                        }
                    }
                    else {
                        $(`.user__${obj}`).html(result[obj]);
                    }
                };
            },
            error: function (error) {
                console.log(error);
            }
        })
    }
});
